import { useCallback } from "react";
import useProfiler from "../../../hooks/useProfiler";
import { createTrackingUtils } from "../index";

const utils = createTrackingUtils({
  name: "flights_funnel_web_condensed_itinerary",
  defaultStage: 1,
  stages: {
    main: 1,
    direct: 2,
    meta: 3
  },
  goals: {}
});

export default function useFlightsFunnelWebCondensedItinerary() {
  const { isMobile, isPb, isDirect } = useProfiler();

  const trackStages = useCallback(() => {
    utils.stages.main();
    if (isDirect()) utils.stages.direct();
    if (!isDirect()) utils.stages.meta();
  }, [isDirect]);

  const isVariant = useCallback(() => {
    if (!isMobile()) return false;
    if (isPb()) return false;
    trackStages();
    return !!utils.trackWithDefaultStage();
  }, [isMobile, trackStages, isPb]);

  return isVariant;
}
